import Header from "components/Headers/Header";
import FetchTable from "../Tables/FetchTable";
import React from "react";
import { VendorsTransactionsModel } from "./../../model/vendors/vendor_transactions_model";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { httpRequest } from "./../../utils/apis";
import { showToast } from "utils/utils";
import { saveByteArray } from "utils/utils";
import { base64ToArrayBuffer } from "utils/utils";

export default function VendorsTransactions() {
  const { token } = useParams();
  VendorsTransactionsModel.request.url =
  VendorsTransactionsModel.request.url + `?token=${token}`;

  useEffect(() => {
    // update url
    //alert("token " + VendorsTransactionsModel.request.url);
    VendorsTransactionsModel.fabs.downloadReport.onClick = () => {
      showToast({ message: "Downloading report...", type: "success" });
      httpRequest({url: VendorsTransactionsModel.request.url + `&report=1`, data: undefined, method: 'get'}).then(response => {
        if (response.status) {
          saveByteArray(
            response.data.fileName,
            base64ToArrayBuffer(response.data.base64),
            response.data.extension
          );
        } else {
          showToast({
            message: response.message || "An error occurred",
            type: "error",
          });
        }
      })
    };
  }, []);

  return (
    <>
      <Header />
      <FetchTable
        settings={{
          name: "Vendor's Transactions",
          table: "",
          control: VendorsTransactionsModel.control,
        }}
        columns={VendorsTransactionsModel.fields}
        records={[]}
        form={VendorsTransactionsModel}
      />
    </>
  );
}
